export function SET_LIVE_SPORTERS(state, sporters) {
  state.liveSporters = sporters
}

export function ADD_LIVE_SPORTER(state, sporter) {
  state.liveSporters.push(sporter)
}

export function UPDATE_LIVE_SPORTER(state, payload) {

    const { key, sporter } = payload
    if (key !== undefined) {
        state.liveSporters[key] = sporter
    } else {
        console.warn('Key is undefined in UPDATE_LIVE_SPORTER')
    }
}

export function ADD_CONNECTION(state, { userId, connection }) {
    console.log(userId, connection)
  state.activeConnections.set(userId, connection)
}

export function REMOVE_CONNECTION(state, userId) {
  state.activeConnections.delete(userId)
}
